import { POST, prefix } from '@utils/lib-request/request';

export const contactUs = (params: any) => POST(`${prefix}/apply/add`, params);
